import { render, staticRenderFns } from "./OtherSite.vue?vue&type=template&id=e180da4c&scoped=true&"
import script from "./OtherSite.vue?vue&type=script&lang=js&"
export * from "./OtherSite.vue?vue&type=script&lang=js&"
import style0 from "./OtherSite.vue?vue&type=style&index=0&id=e180da4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e180da4c",
  null
  
)

export default component.exports